export default __webpack_public_path__ + "static/media/sport-mini.bd6fd686.jpg";